// extracted by mini-css-extract-plugin
export default {"section":"SegmentAdminMapping_section__TvUud","rowContainer":"SegmentAdminMapping_rowContainer__xc3Rg"};